import React, { useContext, useEffect, useState } from "react";

import {} from "./styled";

import DashboardCardTabs from "components/Dashboard/Cards/Tabs";
import DashboardCardTable from "components/Dashboard/Cards/Table";
import { useHistory } from "react-router-dom";
import {
  ContentTableAction,
  ContentTableActionIconAdd,
  ContentTableActionIconEdit,
  ContentTableActionIconRemove,
} from "ui/styled";
import Button from "components/Form/Button";
import { Delete, Read } from "services/employee";
import { exposeStrapiError, normalizeStrapiList } from "utils";
import { toast } from "react-toastify";
import { CoreContext } from "context/CoreContext";
import { ReadByEmail, Delete as DeleteUser } from "services/users";

export default function DashboardListsEmployee() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const { searchExpression, currentCompany } = useContext(CoreContext);

  const actions = [
    { title: "Novo", action: () => navigate("dashboard/employee/add") },
  ];

  const columns = [
    { title: "CPF", ref: "document" },
    { title: "Nome do funcionário", ref: "name" },
    { title: "Departamento", ref: "departament" },
    {
      title: " ",
      renderCell: ({ row }) => (
        <ContentTableAction>
          {currentCompany && currentCompany.statusCancelamento !== true && (
            <Button
              color={"blue"}
              primary
              nospace
              small
              onClick={() => navigate(`dashboard/vacantion/add/${row.id}`)}
            >
              <ContentTableActionIconAdd />
            </Button>
          )}

          <Button
            color={"green"}
            primary
            nospace
            small
            onClick={() => navigate(`dashboard/employee/add/${row.id}`)}
          >
            <ContentTableActionIconRemove />
          </Button>

          <Button
            color={"red"}
            primary
            nospace
            small
            onClick={() => remove(row)}
          >
            <ContentTableActionIconEdit />
          </Button>
        </ContentTableAction>
      ),
    },
  ];

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const parseRegister = (item) => ({
    ...item,
    document: item?.cpf || "",
    name: item?.nome || "",
    departament: item?.office || "",
  });

  const init = async () => {
    setLoading(true);
    try {
      console.log("Iniciando busca de funcionários");
      const result = await Read(currentCompany?.id);

      if (result && !exposeStrapiError(result)) {
        const normalRegister = normalizeStrapiList(result) || [];
        console.log(
          `Total de funcionários encontrados: ${normalRegister.length}`
        );

        const processedEmployees = normalRegister.map(parseRegister);
        setRows(processedEmployees);
        toast.success(`Carregados ${processedEmployees.length} funcionários`);
      } else {
        console.error("Erro ao processar resultado da API:", result);
        toast.error("Erro ao carregar os funcionários");
      }
    } catch (error) {
      console.error("Erro ao carregar funcionários:", error);
      toast.error("Erro ao carregar os funcionários: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const remove = async (row) => {
    try {
      setLoading(true);
      const user = await ReadByEmail(row?.email);
      if (user?.[0]?.id) {
        await DeleteUser(user?.[0]?.id);
      }
      const result = await Delete(row?.id);
      if (result && !exposeStrapiError(result)) {
        toast.success("Removido com sucesso");
        init();
      } else {
        toast.error("Erro ao remover funcionário");
      }
    } catch (error) {
      console.error("Erro ao remover funcionário:", error);
      toast.error("Erro ao remover funcionário: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentCompany?.id) {
      init();
    }
  }, [currentCompany]);

  return (
    <>
      <DashboardCardTabs
        title={"Funcionários cadastrados"}
        actions={actions}
        selectable={{ placeholder: "Ações" }}
      >
        <DashboardCardTable
          rows={rows}
          columns={columns}
          searchExpression={searchExpression}
          loading={loading}
          pagination
        />
      </DashboardCardTabs>
    </>
  );
}
